@if (hasLabel) {
  <div class="sticker">
    {{ label.name }}
  </div>
}
